var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2083 12.5001V26.2501H6.54068C5.89968 26.2501 5.28493 25.9867 4.83167 25.5178C4.37842 25.049 4.12378 24.4131 4.12378 23.7501V6.25006C4.12378 5.58702 4.37842 4.95113 4.83167 4.48229C5.28493 4.01345 5.89968 3.75006 6.54068 3.75006H23.459C24.1 3.75006 24.7147 4.01345 25.168 4.48229C25.6212 4.95113 25.8759 5.58702 25.8759 6.25006V12.5001H16.2083ZM13.7914 12.5001H6.54068V17.5001H13.7914V12.5001ZM13.7914 23.7501V20.0001H6.54068V23.7501H13.7914ZM16.2083 6.25006V10.0001H23.459V6.25006H16.2083ZM13.7914 6.25006H6.54068V10.0001H13.7914V6.25006Z",
    fill: "#546FFF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4591 26.2501V22.5001H19.8337V20.0001H23.4591V16.2501H25.876V20.0001H29.5013V22.5001H25.876V26.2501H23.4591Z",
    fill: "#546FFF",
    fillOpacity: 0.42
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.0028,
    height: 30,
    fill: "white",
    transform: "translate(0.498535)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAdd);
export default __webpack_public_path__ + "static/media/table-add.887e3009ae0e4a2c0f3ed4fbf1e7c67c.svg";
export { ForwardRef as ReactComponent };